import { createReducer } from '@reduxjs/toolkit';
import { ABTUnknownFlags } from '@yandex-int/abt/build/types';
import { setExperiments } from './actions';

interface ExperimentsState {
    flags: Partial<ABTUnknownFlags>;
}

export const experimentsReducer = createReducer<ExperimentsState>(
    {
        flags: {},
    },
    (builder) => {
        builder.addCase(setExperiments, (state, action) => {
            state.flags = action.payload;
        });
    },
);
